import template from './location_zone.html'
import controller from './location_zone.controller'
import './location_zone.scss'

const locationZoneComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationZoneComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/location_zone.component.js